module.exports = __webpack_public_path__ + "img/1420479671.9eb5cd49.jpg";